const ROLES = {
    ROLE_TUTOR : 'Преподаватель',
    ROLE_METHODIST : 'Методист',
    ROLE_CUSTOMER : 'Руководитель организации',
    ROLE_ADMIN : 'Администратор',
    ROLE_USER : 'Студент',
};
export default ROLES;
